// No imports: next.config.ts loads this file outside the app's path aliases.

/**
 * Puts a path under a URL prefix, a locale (/en) or a region (/us). The root under a prefix
 * is the prefix itself, so /en and /en?signup=1, never /en/ or /en/?signup=1, which would
 * each cost a trailing-slash redirect.
 * A run of leading slashes collapses to one: //evil.example is a host to a browser, and with
 * no prefix in front it would leave a same-origin redirect as Location: //evil.example.
 * @param prefix - "" for none, else e.g. "/en"
 * @param rawPath - "" or "/" for the root, else a path starting with "/"
 */
export const joinPrefix = (prefix: string, rawPath: string): string => {
  const path = rawPath.replace(/^\/{2,}/, "/")
  if (path === "" || path === "/") return prefix || "/"
  if (prefix && (path.startsWith("/?") || path.startsWith("/#"))) return `${prefix}${path.slice(1)}`

  return `${prefix}${path}`
}

/** No route segment is two letters long, so after any locale prefix a two-letter segment is a region. */
export const isRegionCode = (segment: string): boolean => /^[a-z]{2}$/.test(segment)
